import { createTheme } from '@mui/material/styles';

const CorpayTheme = 
createTheme({
    typography: {
        "fontFamily": `"GT America", "Avenir Next", "Roboto", "Helvetica", "Arial", sans-serif` 
    },
    palette: {
        primary: {
        main: "#522239", /* "#3D1628",*/
        },
        secondary: {
        main: "#981239",
        },
        tertiary: {
        main: "#1F7BA3",
        },
    },
    components: {
        MuiDataGrid: {
            styleOverrides: {
                row: {
                    "&.Mui-selected": {
                        backgroundColor: "var(--corpay-maroon-light) !important",
                        color: "white",
                        "&:hover": {
                            backgroundColor: "var(--corpay-maroon-dark) !important"
                        }
                    }
                }
            }
        }
    },
});

export default CorpayTheme